export const GET_HSS_MISALIGNMENT_DIAGNOSTIC = "GET_HSS_MISALIGNMENT_DIAGNOSTIC";
export const GET_HSS_MISALIGNMENT_DIAGNOSTIC_SUCCESS = "GET_HSS_MISALIGNMENT_DIAGNOSTIC_SUCCESS";
export const GET_HSS_MISALIGNMENT_DIAGNOSTIC_ERROR = "GET_HSS_MISALIGNMENT_DIAGNOSTIC_ERROR";
